// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0701abf4","239":"c853ac4c","453":"18cdc205","455":"223b50c6"}[chunkId] + ".chunk.js";
};